import { render, staticRenderFns } from "./Speedlist.vue?vue&type=template&id=33c85106&scoped=true"
import script from "./Speedlist.vue?vue&type=script&lang=js"
export * from "./Speedlist.vue?vue&type=script&lang=js"
import style0 from "./Speedlist.vue?vue&type=style&index=0&id=33c85106&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c85106",
  null
  
)

export default component.exports